"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _react = _interopRequireDefault(require("react"));

var _CodeSplitEnvWrapper = _interopRequireDefault(require("pricing-pages-unified-ui/components/CodeSplitEnvWrapper"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  height: 60px;\n  width: 100%;\n\n  .uiButton {\n    width: 100%;\n    height: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var Container = _styledComponents.default.div.withConfig({
  displayName: "BundlesCtaContainer__Container",
  componentId: "sc-1enag8c-0"
})(_templateObject());

var BundlesContainer = function BundlesContainer(props) {
  return _react.default.createElement(Container, null, _react.default.createElement(_CodeSplitEnvWrapper.default, {
    authedComponentLoader: function authedComponentLoader() {
      return import(
      /* webpackChunkName: "authed-chunk" */
      "pricing-pages-unified-ui/components/bundle-page/BundlesAuthedCta");
    },
    publicComponentLoader: function publicComponentLoader() {
      return import(
      /* webpackChunkName: "public-chunk" */
      "pricing-pages-unified-ui/components/public-only/PublicPurchaseMotionButton");
    },
    authedComponentProps: (0, _extends2.default)({}, props),
    publicComponentProps: {
      use: 'primary',
      sourceId: 'pricing-middle',
      nonMerchandiseIdProduct: 'bundle'
    }
  }));
};

var _default = BundlesContainer;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/bundle-page/BundlesCtaContainer.js
// module id = 715
// module chunks = 5 6